import { useRef, useState, useEffect } from 'react';
import styles from './header.module.css';
import { useNavigate } from 'react-router-dom';
import { NavigationPaths, TOKEN_KEY } from '../../constants';
import { resetAuthState } from '../../reducers/authReducer';
import { resetAdminState } from '../../reducers/adminReducer';
import { resetOrganisationState } from '../../reducers/organizationReducer';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { resetCurrencyState } from '../../reducers/rateReducer';
import { useTranslation } from 'react-i18next';
import { LanguageSelectorHeader } from '../language/language-selector-header';

export const Header = () => {
  const { t } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { organisation } = useSelector((state: RootState) => state.organization);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem(TOKEN_KEY);
    dispatch(resetAuthState());
    dispatch(resetAdminState());
    dispatch(resetOrganisationState());
    dispatch(resetCurrencyState());
    setIsDropdownOpen(false);
    navigate(NavigationPaths.LOGIN);
  };

  const handleOutsideClick = (e: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isDropdownOpen]);

  return (
    <div className={styles.header}>
      <span className={styles.orgName}>{t('clientOrganisation')}</span>

      <div
        className={styles.profile}
        ref={dropdownRef}
      >
        <LanguageSelectorHeader />
        <span
          className={styles.profileName}
          onClick={toggleDropdown}
        >
          {organisation?.name}
        </span>
        {isDropdownOpen && (
          <div className={styles.dropdown}>
            <button
              className={styles.dropdownItem}
              onClick={handleLogout}
            >
              {t('logout')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
